import { createApp } from 'vue'
import App from '@/App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import router from "@/router"
import LC from '@/api'
import { setQuery, loadList, loadDetail, search, del, add, detail, confirm, reset } from '@/utils'

LC.init({})

const app = createApp(App)
app.use(router)
app.use(Antd)
app.mount('#app')
app.config.productionTip = false
app.config.globalProperties.$lc = LC
app.config.globalProperties.$setQuery = setQuery
app.config.globalProperties.$loadList = loadList
app.config.globalProperties.$loadDetail = loadDetail
app.config.globalProperties.$search = search
app.config.globalProperties.$del = del
app.config.globalProperties.$add = add  
app.config.globalProperties.$detail = detail
app.config.globalProperties.$confirm = confirm
app.config.globalProperties.$reset = reset

app.config.globalProperties.$user = LC.User.current();
